import TabPanel from '../../utilsComponents/TabPanel'
import PreferencesSwitch from './PreferencesGeneralTabSwitch'
import { PreferenceGeneralTabProps } from './_props'
import PreferencesGeneralForm from './PreferencesGeneralForm'

const PreferenceGeneralTab = ({
    value,
    index,
    switches,
    handleSwitchesChange,
    switchDisplay,
    medicalMailProcess,
    handleMedicalProcessChange,
    admMailProcess,
    handleAdmProcessChange,
}: PreferenceGeneralTabProps) => (
    <TabPanel value={value} index={index}>
        <PreferencesSwitch
            checked={switches.canForcePassword}
            onChange={handleSwitchesChange}
            name="canForcePassword"
            label="Les gestionnaires peuvent définir les mots de passe."
        />
        <PreferencesSwitch
            checked={switches.passwordRotationEnabled}
            onChange={handleSwitchesChange}
            name="passwordRotationEnabled"
            label="La rotation des mots de passe, tous les 90 jours, est activée."
        />
        {switchDisplay.automaticValidationDisabled && (
            <PreferencesSwitch
                checked={switches.automaticValidationDisabled}
                onChange={handleSwitchesChange}
                name="automaticValidationDisabled"
                label="Désactiver la validation automatique des identités INS à partir d'un document à haut niveau de
                        confiance."
            />
        )}
        <PreferencesGeneralForm
            medicalMailProcess={medicalMailProcess}
            handleMedicalProcessChange={handleMedicalProcessChange}
            admMailProcess={admMailProcess}
            handleAdmProcessChange={handleAdmProcessChange}
        />
    </TabPanel>
)

export default PreferenceGeneralTab
